import React from "react";

const HelpSection = () => {
  const help1 = require("./images/help-1.svg");
  const help2 = require("./images/help-2.svg");
  const help3 = require("./images/help-3.svg");
  const help4 = require("./images/help-4.svg");

  return (
    <section className="photos-help-section">
      <div className="container-lock bg-lt-green br-15 photos-help-container">
        <h2>Looking for help?</h2>
        <div className="flex-row photos-help-divs">
          <a
            href="http://help.geosnapshot.com/en/articles/1828297-how-to-search-for-photos"
            target="_blank"
            rel="noopener noreferrer"
            className="photos-help-div"
          >
            <img src={help1} />
            <span>
              <b>
                How to search <br />
                for photos
              </b>
            </span>
            <hr />
          </a>
          <a
            href="http://help.geosnapshot.com/en/articles/834228-how-to-purchase-photos-using-geosnapshot"
            target="_blank"
            rel="noopener noreferrer"
            className="photos-help-div"
          >
            <img src={help2} />
            <span>
              <b>How to pay for photos</b>
            </span>
            <hr />
          </a>
          <a href="/photographers" target="_blank" rel="noopener noreferrer" className="photos-help-div">
            <img src={help3} />
            <span>
              <b>How to share or sell your own photos</b>
            </span>
            <hr />
          </a>
          <a
            onClick={_ => {
              // @ts-ignore
              Intercom("show");
            }}
            className="photos-help-div"
          >
            <img src={help4} />
            <span>
              <b>
                Ask us a<br /> question
              </b>
            </span>
            <hr />
          </a>
        </div>
      </div>
    </section>
  );
};

export default HelpSection;
